<template>
    <ab-flow-base-cmp :movable="true" :block="block" class="stop-sound-editor-cmp">
        <ab-flow-link-connector :block="block" type="input" class="ev-run" event="run"/>
        <q-card>

            <q-card-section class="bg-yellow-8 text-black">
              Stop channel: {{soundChannel}}
            </q-card-section>

        </q-card>

        <div class="results">
            <ab-flow-link-connector class="q-mt-sm" :block="block" type="output" event="stopped"/>
        </div>

    </ab-flow-base-cmp>
</template>

<script>

import AbFlowBaseCmp from "ab-flow-designer/src/components/Designer/AbFlowBaseCmp";
import AbFlowLinkConnector from "ab-flow-designer/src/components/Designer/AbFlowLinkConnector";

export default {
    components: { AbFlowBaseCmp, AbFlowLinkConnector},
    inject: ['canvas'],
    props: ['block'],
    name: "StopSoundEditorCmp",
    computed: {

        /**
         * Sound channel
         * @return {{}}
         */
        soundChannel() {
            return this.block.properties?.soundChannel?.title || "n/a"
        },
    }
}

</script>

<style lang="scss">

.stop-sound-editor-cmp {
  .ev-run {
    left:-12px;
    position: absolute;
    top:calc(50% - 5px);
  }

  .results {
    position: absolute;
    right: -12px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

</style>
